import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import AntIcon from '@ant-design/icons/lib/components/Icon';
export var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(AntIcon, _extends({}, props, {
    style: {
      fontSize: props.size,
      color: props.color
    },
    rev: undefined
  }));
};